const state = {
  sets: [],
  tiers: [],
  server: null,
  error: null
}

const getters = {
  randomSetsEntries: state => state.sets,
  randomSetsTiers: state => state.tiers,
  randomSetsServer: state => state.server,
  randomSetsError: state => state.error
}

const actions = {
  getRandomSets ({ commit }, payload) {
    commit('setRandomSets', payload)
  },
  setError ({ commit }, payload) {
    commit('setError', payload.data)
  }
}

const mutations = {
  setRandomSets (state, payload) {
    const data = payload && payload.data ? payload.data.data : null
    state.sets = data && data.sets ? data.sets : []
    state.tiers = data && data.tiers ? data.tiers : []
    state.server = payload && payload.data ? payload.data.server : null
    state.error = null
  },
  setError (state, error) {
    state.error = { error, time: Date.now() }
  }
}

export default {
  state,
  getters,
  actions,
  mutations
}
